/** @format */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonShape } from '../../../models/skeleton-loader.interface';

@Component({
	selector: 'product-reviews-skeleton',
	templateUrl: './skeleton.component.html',
	styleUrl: './skeleton.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule]
})
export class SkeletonComponent {
	@Input() skeletonShape: SkeletonShape;
	@Input() skeletonCount: number;
}
